import CryptoJS from "crypto-js";
import { emptyString } from "../constants";
import { clearUserData } from "./utility-functions";

export const encryptObject = (object) => {
  return CryptoJS.AES.encrypt(
    JSON.stringify(object),
    process.env.REACT_APP_CRYPTO_SECRET_KEY
  ).toString();
};

export const decryptObject = (encryptedString) => {
  try {
    if (encryptedString !== emptyString) {
      const bytes = CryptoJS.AES.decrypt(
        encryptedString,
        process.env.REACT_APP_CRYPTO_SECRET_KEY
      );
      return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } else {
      return {};
    }
  } catch (e) {
    clearUserData();
    window.location.reload();
  }
};

// ------------------- Decrypt Payload
export const getDecryptPayload = (encryptedPayload) => {
  return decryptObject(encryptedPayload);
};
